import { IconButton, InputAdornment } from '@mui/material';
import CrossIcon from 'assets/img/icons/cross.svg?react';
import { FieldValues, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SearchFilterInputProps } from './search-filter-input.types';
import { LwFormInput } from '../input';

const LwSearchFilterInput = <ControlFields extends FieldValues = FieldValues>({
  name,
  control,
  rules,
  disabled,
  onChange,
  label,
  placeholder,
  'data-testid': dataTestId,
}: SearchFilterInputProps<ControlFields>) => {
  const { t } = useTranslation('web-common');
  const { field } = useController({ name, control, rules });

  const handleClear = () => {
    field.onChange('');
    onChange?.('');
  };

  return (
    <LwFormInput
      name={name}
      control={control}
      rules={rules}
      disabled={disabled}
      label={label ?? t('forms.search-input.label', { defaultValue: 'Zoeken' })}
      placeholder={
        placeholder ??
        t('forms.search-input.placeholder', { defaultValue: 'Naam, email of telefoonnummer' })
      }
      data-testid={dataTestId}
      onChange={(event) => {
        onChange?.(event.target.value);
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={t('forms.search-input.clear-label', { defaultValue: 'veld leegmaken' })}
              disabled={disabled}
              onClick={handleClear}
              onMouseDown={(event) => event.preventDefault()}
            >
              <CrossIcon width={20} height={20} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export { LwSearchFilterInput };
